import React from "react";
import classes from "./StayTuned.module.css";

//components
import Button from "../../../UI/Button/Button";

//This component displays form for Stay Tuned
const StayTuned = (props) => {
  return (
    <div className={classes.container}>
      <div className={classes.item}>
        <div className={classes.label}>Full Name: </div>
        <input className={classes.textField} />
      </div>
      <div className={classes.item}>
        <div className={classes.label}>Email: </div>
        <input className={classes.textField} />
      </div>
      <div className={classes.rowCenter}>
        <Button width={150} height={50}>
          Submit
        </Button>
      </div>
    </div>
  );
};
export default StayTuned;
